const canvasApis = {
  /**
   * 营销画布页面接口
   */
  createActivity: { // 创建活动
    url: '/campaign/campaigns',
    method: 'POST'
  },
  getActivityList: { // 获取画布活动列表
    url: '/campaign/campaigns',
    method: 'GET',
  },
  copyActivityList: { // 复制活动
    url: '/campaign/{campaignId}/copies',
    method: 'POST',
    hasPathParams: true,
  },
  updateActivityList: { // 更新活动
    url: '/campaign/campaign/{campaignId}',
    method: 'PUT',
    hasPathParams: true,
  },
  deleteActivityList: { // 删除活动
    url: '/campaign/campaigns',
    method: 'DELETE',
  },
  submitActivity: { // 提交画布流程
    url: '/campaign/{campaignId}/inprogress',
    method: 'POST',
    hasPathParams: true,
  },
  preActivity: { // 预执行画布流程
    url: '/campaign/{campaignId}/inpreprogress',
    method: 'POST',
    hasPathParams: true,
  },
  stopPreActivity: { // 停止预执行
    url: '/campaign/{campaignId}/inprogress',
    method: 'PATCH',
    hasPathParams: true,
  },
  continuePreActivity: { // 继续预执行
    url: '/campaign/{campaignId}/inpreprogress',
    method: 'PUT',
    hasPathParams: true,
  },
  continueActivity: { // 继续画布流程运行
    url: '/campaign/{campaignId}/inprogress',
    method: 'PUT',
    hasPathParams: true,
  },
  pauseActivity: { // 暂停画布流程运行
    url: '/campaign/{campaignId}/inprogress',
    method: 'DELETE',
    hasPathParams: true,
  },
  stopActivity: { // 停止画布流程运行
    url: '/campaign/{campaignId}/inprogress',
    method: 'PATCH',
    hasPathParams: true,
  },
  getCanvasCrowdList: { // 获取人群列表
    url: '/people/crowpeople',
    method: 'GET',
  },
  saveProcess: { // 保存画布流程
    url: '/campaign/processes',
    method: 'POST',
  },
  updateProcess: { // 更新画布流程
    url: '/campaign/{campaignId}/process',
    method: 'PUT',
    hasPathParams: true,
  },
  getCanvasProcess: { // 获取画布流程
    url: '/campaign/{campaignId}/process',
    method: 'GET',
    hasPathParams: true,
  },
  getCanvasProcessPreDetail: { // 获取画布流程预执行详细运行数据
    url: '/campaign/{campaignId}/process/pre/detail',
    method: 'GET',
    hasPathParams: true,
  },
  getCanvasProcessDetail: { // 获取画布流程详细运行数据
    url: '/campaign/{campaignId}/process/detail',
    method: 'GET',
    hasPathParams: true,
  },
  getCanvasTemplate: { // 获取画布流程模板
    url: '/campaign/templates',
    method: 'GET',
  },
  saveCanvasTemplate: { // 获取画布流程模板
    url: '/campaign/templates',
    method: 'POST',
  },
  // getCanvasPower: { // 白名单商家可以无限操作节点，没有权限只可以操作少量节点
  //   url: '/userwhite/crowdcanvaswhite',
  //   method: 'GET',
  // },
  getCanvasPower: { // 白名单商家可以无限操作节点，没有权限只可以操作少量节点，新接口，上面接口作废
    url: '/whiteuserfunction/userList',
    method: 'GET',
  },
  saveNewCrowd: { // 画布各节点保存人群包
    url: '/people/peoplePreservation',
    method: 'POST'
  },
  saveSecondaryMarketingCrowd: {   // 生成二次营销人群
    url: '/taskcrowd/secondarymarketingcrowd',
    method: 'POST'
  },
  getSecondaryMarketingCrowd: {   // 获取二次营销人群
    url: '/taskcrowd/secondarymarketingcrowd',
    method: 'GET'
  },
  batchCreateSecondaryMarketingCrowd: {//批量生成二次营销人群
    url: '/taskcrowd/secondarymarketingcrowd/batch',
    method: 'POST'
  },
  getChartList: { //获取画布报表列表
    url: '/sms/doudiansms/effect/effectreport',
    method: 'GET'
  },
  // 画布系统模板获取
  getCanvasSystemTemplate: {
    url: '/campaign/canvas/model/template',
    method: 'GET'
  },
  setExcludeMoreInfo: { // 填写排除人群调研报告
    url: '/function/opinion/collection',
    method: 'GET'
  },

  getCompagainId: { // 获取活动ID
    url: '/campaign/activityid',
    method: 'GET'
  },
  getSalesWhiteList: { // 获取优惠促销白名单
    url: '/msgbox/checkwhitelist',
    method: 'GET'
  },
  getSalesCheckUrl: { // 校验链接
    url: '/whiteurl/checkurl',
    method: 'GET'
  },
  checkTime: { // 校验时间是否合规
    url: '/smstimelimitconfig/rationality',
    method: 'GET'
  },
  getCanvasNodeData: {  // 获取画布节点运行数据
    url: '/campaign/task/detail',
    method: 'GET'
  },
  testDetailExport: {   // 画布节点数据导出
    url: '/campaign/taskdetailexcelout',
    method: 'POST',
    isDownload: true
  },
  checkrecordcanuse: {  // 校验优惠券是否可用
    url: '/crowdcoupon/checkrecordcanuse',
    method: 'GET'
  },
  newBatchExport: {  // 画布效果报表数据导出
    url: '/sms/doudiansms/effect/complete/out',
    method: 'POST',
    isDownload: true
  },
  canvasSmsBatchTemplateDown: {
    url: '/campaign/exceltemplate',
    method: 'POST',
    isDownload: true,
    downSuffix: 'xlsx'
  },
}

const exportObj = {};
Object.keys(canvasApis).forEach((key) => {
    exportObj[key] = {
        ...canvasApis[key],
        url: `/api${canvasApis[key].url}`
        // instanceName: 'marketing-request'
    }
});

export default exportObj;
